// @flow

import React from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import drawerColumn from '../../drawerColumn/drawerColumn.container';
import { getResultCount } from '../../../store/assortment';
import { getResultTitle, getResultTitlePlural, getCloseText } from '../../../store/assortmentSettings';

export const FACETS_COLUMN_NAME = 'facets-column-drawer';
const FilterColumn = drawerColumn(FACETS_COLUMN_NAME);

// @TODO: fix this: Node | Array<Node> doesn't seem to work
type OwnProps = {|
  children: Node,
|};

type StateProps = {|
  count: number,
  resultTitle: string,
  resultTitlePlural: string,
  closeText: string,
|};

type Props = {|
  ...StateProps,
  ...OwnProps,
|};

const FilterDrawer = ({
  children,
  count,
  resultTitle,
  resultTitlePlural,
  closeText,
}: Props) => (
  <FilterColumn
    position="left"
    title={`${count} ${count === 1 ? resultTitle : resultTitlePlural}`}
    closeText={closeText}
    overlay
  >
    {children}
  </FilterColumn>
);

const mapStateToProps = (state): StateProps => ({
  count: getResultCount(state),
  resultTitle: getResultTitle(state),
  resultTitlePlural: getResultTitlePlural(state),
  closeText: getCloseText(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(FilterDrawer);
